{#if fields?.images?.length}
  <div class="jolojo-gallery {columnClasses[fields.columns]}"
    style="gap: {fields.gap}px;
      {fields.maxWidth ? `max-width: ${fields.maxWidth}px;` : ''}
    "
  >
    {#each fields.images as image, i (image.id)}
      <div class="jolojo-gallery-image"
        style:border={fields.borderColour && fields.borderWidth ? `solid ${fields.borderWidth}px ${fields.borderColour}` : ''}
        on:click={() => openFullScreenGallery(i)}
      >
        <LazyImg src={image.src} alt={image?.alt || 'Gallery Image'}
          style={`
          ${fields.imageFit ? `object-fit: ${fields.imageFit};` : ''}
          ${fields?.aspectRatio?.width && fields?.aspectRatio?.height ? `aspect-ratio: ${fields.aspectRatio.width}/${fields.aspectRatio.height};` : ''}
        `}
        />
      </div>
    {/each}
  </div>
{:else if isLoggedIn}
  <div class="no-slides">
    <h3>Gallery</h3>
    <p>Enter edit mode and select this plugin to begin adding images</p>
  </div>
{/if}

{#if fullScreenGalleryOpen}
  <div class="full-screen-gallery">
    <div class="full-screen-gallery-image">
      <LazyImg src={fields.images[fullScreenGalleryIndex].src} alt="Gallery image" />
    </div>
    <svg class="prev-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" on:click={prevImage}>
      <path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"/>
    </svg>
    <svg class="next-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" on:click={nextImage}>
      <path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/>
    </svg>
    <svg class="close-gallery" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" on:click={() => { fullScreenGalleryOpen = false }}>
      <path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
    </svg>
    <div class="image-information">
      <div class="image-title">
        <span>{fields.images[fullScreenGalleryIndex]?.title || ''}</span>
      </div>
      <div class="image-index">
        {fullScreenGalleryIndex + 1} / {fields.images.length}
      </div>
    </div>
  </div>
{/if}

<script>
  import { getContext, onMount } from 'svelte'
  import LazyImg from '@/components/core/extensions/lazy_img/v1.0.0/LazyImg.svelte'

  export let fields = {}

  let fullScreenGalleryOpen = false
  let fullScreenGalleryIndex = 0

  onMount(() => {
    window.addEventListener('keydown', (e) => {
      if (fullScreenGalleryOpen) {
        switch (e.key) {
          case 'ArrowLeft':
            prevImage()
            break
          case 'ArrowRight':
            nextImage()
            break
          case 'Escape':
            fullScreenGalleryOpen = false
            break
        }
      }
    })
  })

  function openFullScreenGallery (index) {
    fullScreenGalleryIndex = index
    fullScreenGalleryOpen = true
  }

  function prevImage () {
    if (fullScreenGalleryIndex === 0) {
      fullScreenGalleryIndex = fields.images.length - 1
    } else {
      fullScreenGalleryIndex--
    }
  }

  function nextImage () {
    if (fullScreenGalleryIndex === fields.images.length - 1) {
      fullScreenGalleryIndex = 0
    } else {
      fullScreenGalleryIndex++
    }
  }

  const platform = getContext('platform')
  const isLoggedIn = platform.api.core.isLoggedIn()

  const columnClasses = {
    1: 'jolojo-gallery-one-column',
    2: 'jolojo-gallery-two-columns',
    3: 'jolojo-gallery-three-columns',
    4: 'jolojo-gallery-four-columns',
    5: 'jolojo-gallery-five-columns',
    6: 'jolojo-gallery-six-columns',
  }

</script>

<style lang="scss">.no-slides {
  width: 100%;
  outline: dashed 2px #888;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  padding: 15px;
  box-sizing: border-box;
  text-emphasis: center;
}

.cover-frame {
  width: 100%;
}
.cover-frame :global(img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.center-image {
  display: grid;
  place-items: center;
}

.jolojo-gallery {
  display: grid;
  cursor: zoom-in;
}

.jolojo-gallery-one-column {
  grid-template-columns: 1fr;
}

.jolojo-gallery-two-columns {
  grid-template-columns: 1fr 1fr;
}

.jolojo-gallery-three-columns {
  grid-template-columns: 1fr 1fr 1fr;
}

.jolojo-gallery-four-columns {
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.jolojo-gallery-five-columns {
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.jolojo-gallery-six-columns {
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}

@media (max-width: 1000px) {
  .jolojo-gallery {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 650px) {
  .jolojo-gallery {
    grid-template-columns: 1fr;
  }
}

.full-screen-gallery {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px) brightness(0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.full-screen-gallery-image {
  width: calc(90% - (20px + 5vw));
  height: calc(90% - 50px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.full-screen-gallery-image :global(img) {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.prev-image {
  position: absolute;
  left: 2.5vw;
}

.next-image {
  position: absolute;
  right: 2.5vw;
}

.close-gallery {
  position: absolute;
  top: 2.5vh;
  right: 2.5vw;
}

.next-image, .prev-image, .close-gallery {
  height: clamp(25px, 2vw, 50px);
  cursor: pointer;
}

.image-information {
  position: absolute;
  width: calc(90% - (20px + 5vw));
  bottom: 5%;
  font-size: clamp(12px, 1.4vw, 24px);
  display: flex;
  justify-content: space-between;
  color: white;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>